import { HelpMedia } from "./helpMedia";
import { Box, ButtonBase } from "@mui/material";
import { PlayIcon } from "components/ui/icons";
import React, { useState } from "react";

/**
 * A video's poster with a play button. Nothing plays until it is pressed.
 * Draws nothing if the poster does not load: with media uploaded by
 * convention, a missing folder is only detectable that way, and no player is
 * better than a broken one.
 */
const HelpPoster = ({
  media,
  title,
  onPlay,
}: {
  media: HelpMedia;
  title: string;
  onPlay: () => void;
}) => {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return null;
  }
  return (
    <ButtonBase
      onClick={onPlay}
      aria-label={`Play video: ${title}`}
      sx={{
        position: "relative",
        display: "block",
        width: "100%",
        aspectRatio: "16 / 9",
        borderRadius: 1.5,
        overflow: "hidden",
        bgcolor: "#000",
        "&:hover .help-play, &:focus-visible .help-play": {
          transform: "translate(-50%, -50%) scale(1.08)",
        },
      }}
    >
      <Box
        component="img"
        src={media.poster}
        alt=""
        onError={() => setFailed(true)}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
      <Box
        className="help-play"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 64,
          height: 64,
          borderRadius: "50%",
          bgcolor: "error.main",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: 4,
          "@media (prefers-reduced-motion: no-preference)": {
            transition: "transform 120ms ease-out",
          },
        }}
      >
        <PlayIcon sx={{ fontSize: 40 }} />
      </Box>
    </ButtonBase>
  );
};

export default HelpPoster;
